import { FC } from 'react';
import { Box, Card, Flex, Text } from 'roo-ui/components';
import { useDetailsBooking } from 'lib/hooks';
import { getPendingScheduledPayment } from 'lib/bookingInfo';
import { updateCreditCardDetailsLinkSelected } from 'lib/gaTracking/bookingDetailsPageEvents';
import { FormattedMoney, FormattedCalendarDate } from 'components/Formatters';
import { HorizontalRule } from 'components/Layout';
import { ActionItem } from '../ActionBar';
import { FLAG_UPDATE_PAYMENT_METHOD } from 'config';

const DepositPayActions: FC = () => {
  const { booking } = useDetailsBooking();
  const scheduledPayment = getPendingScheduledPayment(booking);
  if (!scheduledPayment) {
    return null;
  }

  const total = scheduledPayment.creditCardPaymentAllocation.allocation;
  const paymentDueDate = scheduledPayment.deferredTo;

  return (
    <Card data-testid="deposit-pay-actions" display="flex" flexDirection="column" textAlign="left" borderRadius="default" p={0} mb={4}>
      <Flex flexDirection="row" justifyContent="space-between" m={4} mb={0}>
        <Text data-testid="scheduled-payment-label" as="div" fontSize="lg">
          Final payment scheduled
        </Text>
        <Text data-testid="scheduled-payment-total" as="div" fontSize="lg" textAlign="right">
          <FormattedMoney {...total} />
        </Text>
      </Flex>
      <Text data-testid="scheduled-payment-summary" as="div" m={4} mt={3}>
        Your final scheduled payment of <FormattedMoney {...total} /> is due on <FormattedCalendarDate date={paymentDueDate} />
      </Text>
      {FLAG_UPDATE_PAYMENT_METHOD && (
        <>
          <HorizontalRule m={0} />
          <Box p={4}>
            <ActionItem
              dataTestId="scheduled-payment-update-credit-card-link"
              icon="creditCard"
              label="Update credit card details"
              url={booking.links.updatePaymentMethod}
              external={true}
              onClick={updateCreditCardDetailsLinkSelected}
            />
          </Box>
        </>
      )}
    </Card>
  );
};

export default DepositPayActions;
